import styled from 'styled-components'

export const TooltipContent = styled.div`
  max-width: 200px;
  text-align: ${({ textAlign }) => textAlign};
`
